import React from 'react'

const CollapseContext = React.createContext<boolean | undefined>(undefined)

export const CollapseContextProvider = CollapseContext.Provider

export const CollapseContextConsumer = CollapseContext.Consumer

export default CollapseContext
